import type { ModerationScanner } from '@planuze/admin-contracts';
import type { ModerationScannerContent } from '../../content/sections/moderation-scanner.js';

/* Descritores dos campos da config de moderação. Extraído do form (§4.7) para manter o
   componente enxuto. Os TEXTOS (label/tooltip) vêm de `content/sections/moderation-scanner.ts` —
   este módulo só monta os descritores (`key` + acesso ao campo do contrato) a partir da copy
   recebida, e por isso não é uma constante de módulo: `limitFields`/`heuristicFields` são funções
   chamadas dentro do componente com `copy` já resolvida pelo hook. */

export type Severity = 'error' | 'warning' | 'info';
export const SEVERITIES: readonly Severity[] = ['error', 'warning', 'info'];

export interface NumericFieldDescriptor {
  readonly key: keyof ModerationScanner;
  readonly label: string;
  readonly tooltip: string;
}

/** Card "Limites e timeouts": tetos de custo e janelas de tempo do scan. */
export function limitFields(copy: ModerationScannerContent): readonly NumericFieldDescriptor[] {
  return [
    {
      key: 'maxFindings',
      label: copy.limitFields.maxFindingsLabel,
      tooltip: copy.limitFields.maxFindingsTooltip,
    },
    {
      key: 'maxArchiveBytes',
      label: copy.limitFields.maxArchiveBytesLabel,
      tooltip: copy.limitFields.maxArchiveBytesTooltip,
    },
    {
      key: 'timeoutMs',
      label: copy.limitFields.timeoutMsLabel,
      tooltip: copy.limitFields.timeoutMsTooltip,
    },
    {
      key: 'scanTimeoutMs',
      label: copy.limitFields.scanTimeoutMsLabel,
      tooltip: copy.limitFields.scanTimeoutMsTooltip,
    },
  ];
}

/** Card "Heurísticas de detecção": limiares que escalam a severidade de regras. */
export function heuristicFields(copy: ModerationScannerContent): readonly NumericFieldDescriptor[] {
  return [
    {
      key: 'dataPayloadMinBase64',
      label: copy.heuristicFields.dataPayloadMinBase64Label,
      tooltip: copy.heuristicFields.dataPayloadMinBase64Tooltip,
    },
    {
      key: 'maxVendoredFiles',
      label: copy.heuristicFields.maxVendoredFilesLabel,
      tooltip: copy.heuristicFields.maxVendoredFilesTooltip,
    },
  ];
}
